export const menuSuperadmin = {
    menu: [
        {
            label: 'front.menuAdmin.suivi',
            icon: 'view_timeline',
            children: [
                {
                    label: 'menu.listeDesDossiers',
                    url: '/administration/dossiers/liste'
                },
                {
                    label: 'Rapports scientifiques',
                    url: '/datavis/suivi_rapports_scientifiques'
                },
                {
                    label: 'Prolongations',
                    url: '/administration/liste-demande-prolongation'
                },
                {
                    label: 'Budgets',
                    url: '/administration/liste-modifications-budgetaires'
                },
                {
                    label: 'front.menuAdmin.group3',
                    url: '/datavis/candidatures-stats'
                },
                {
                    label: 'menu.dossierDetaille',
                    url: '/dossiers/mes-expertises-reunion'
                }
            ]
        },
        {
            label: 'front.menuAdmin.group2',
            icon: 'class',
            children: [
                {
                    label: 'general.aides',
                    url: '/aides-commissions/aides'
                },
                {
                    label: 'general.listCommissions',
                    url: '/commissions/seances/liste'
                },
                {
                    label: 'general.mandatsUtilisateurs',
                    url: '/administration/infos-experts'
                },
                {
                    label: 'general.expertSansMandat',
                    url: '/administration/infos-expert-sans-mandat'
                }
            ]
        },
        {
            label: 'front.menuAdmin.group4.label',
            icon: 'folder_special',
            children: [
                {
                    label: 'front.menuAdmin.group4.item1',
                    url: '/datavis/nommer'
                },
                {
                    label: 'front.expertises.experts.title',
                    url: '/datavis/experts'
                },
                {
                    label: 'Expertises ADMIN',
                    url: '/dossiers/mes-expertises'
                }
            ]
        },
        {
            label: 'front.menuAdmin.group5',
            icon: 'announcement',
            children: [
                {
                    label: 'general.listeDesDecisions',
                    url: '/administration/dossiers/decision'
                },
                {
                    label: 'menu.decisionsAAP',
                    url: '/datavis/decisions-list'
                },
                {
                    label: 'general.notifs',
                    url: '/administration/notifs'
                },
                {
                    label: 'front.menuAdmin.suiviDesistements',
                    url: '/administration/dashboards/desistements'
                },
                {
                    label: 'front.menuAdmin.ajustementWorkflowDossier',
                    url: '/administration/dossiers/ajustement-workflow'
                }
            ]
        },
        {
            label: 'front.menuAdmin.group6',
            icon: 'print',
            children: [
                {
                    label: 'general.etats',
                    url: '/exports/etats'
                },
                {
                    label: 'general.exports',
                    url: '/exports'
                },
                {
                    label: 'general.exportsParAAP',
                    url: '/exports/parAAP'
                },
                {
                    label: 'Export des fichiers',
                    url: '/exports/fichiers'
                }
            ]
        },
        {
            label: 'front.menuAdmin.group7',
            icon: 'settings_applications',
            children: [
                {
                    label: 'general.faq',
                    url: '/administration/faq'
                },
                {
                    label: 'Maintenance',
                    url: '/administration/maintenances'
                },
                {
                    label: 'Contact',
                    url: '/administration/contact'
                },
                {
                    label: 'Paramétrage ADMIN',
                    children: [
                        {
                            label: 'Edition des e-mails',
                            url: '/administration/messages/mails'
                        },
                        {
                            label: 'Edition des notifications',
                            url: '/administration/messages/notifications'
                        },
                        {
                            label: 'general.listeDesStructures',
                            url: '/administration/laboratoires'
                        },
                        {
                            label: 'front.listeInserm.listeInserm',
                            url: '/administration/liste-inserm'
                        },
                        {
                            label: 'front.listeCnrs.listeCnrs',
                            url: '/administration/liste-cnrs'
                        },
                        {
                            label: 'front.listeUniv.listeUniv',
                            url: '/administration/liste-universite'
                        },
                        {
                            label: 'Formulaires Masters Rapports Scientifiques',
                            url: '/administration/liste-master-rs'
                        },
                        {
                            label: 'Cofinanceurs',
                            url: '/administration/cofinanceurs'
                        },
                    ]
                },
                {
                    label: 'Paramétrage superviseur',
                    children: [
                        {
                            label: 'general.charteDeonthologie',
                            url: '/administration/textes/charte-deontologique'
                        },
                        {
                            label: 'general.declaPubliqueInteret',
                            url: '/administration/textes/declaration-publique'
                        },
                        {
                            label: 'general.politiqueProtectionDonnees',
                            url: '/administration/textes/politique-protection-donnees'
                        },
                        {
                            label: 'general.mentionsLegales',
                            url: '/administration/textes/mentions-legales'
                        },
                        {
                            label: 'general.typeAides',
                            url: '/aides-commissions/categorie-aide'
                        },
                        {
                            label: 'general.sousTypeAides',
                            url: '/aides-commissions/type-aide'
                        },
                        {
                            label: 'Départements',
                            url: '/administration/liste-departements'
                        },
                        {
                            label: 'Régions',
                            url: '/administration/liste-regions'
                        },
                        {
                            label: 'Instances',
                            url: '/commissions/liste'
                        },
                        {
                            label: 'Localisations',
                            url: '/administration/localisations'
                        },
                        {
                            label: 'Identifications thematiques',
                            url: '/administration/identification-thematique'
                        },
                        {
                            label: 'CSO',
                            url: '/administration/cso'
                        },
                        {
                            label: 'Cancéropôles',
                            url: '/administration/canceropoles'
                        },
                        {
                            label: 'Types publications',
                            url: '/administration/liste-types-publication'
                        }
                    ]
                }
            ]
        },
        {
            label: 'front.menuAdmin.group1',
            icon: 'person',
            url: '/administration/utilisateurs',
            children: []
        }
    ],
    classKey: 'admin'
};
